import FiltersState from './filters-state';
import Action from '../../state/action';

const filtersReducer = (state: FiltersState, action: Action): FiltersState => {
  switch (action.type) {
    case 'initialize-filter':
    case 'filter-by':
      return {
        ...state,
        maps: { ...state.maps, ...action.filters.maps },
        keywords: { ...state.keywords, ...action.filters.keywords },
        categories: {
          ...state.categories,
          ...action.filters.categories,
        },
        locations: {
          ...state.locations,
          ...action.filters.locations,
        },
        companies: {
          ...state.companies,
          ...action.filters.companies,
        },
        targetGroups: {
          ...state.targetGroups,
          ...action.filters.targetGroups,
        },
        orgUnits: {
          ...state.orgUnits,
          ...action.filters.orgUnits,
        },
        languages: {
          ...state.languages,
          ...action.filters.languages,
        },
      };
    default:
      return state;
  }
};

export default filtersReducer;
